import TagManager from 'react-gtm-module';
import { TrackCartEventItem } from './gtm/ga4/trackAddToCartEvent';
import {
  createCategoryPath,
  productDescriptionComingSoon,
} from './gtm/ga4/utils';

export const createDataLayerProduct = (
  product: TrackCartEventItem,
  productCode: string
) => {
  let noItemDescription;
  if (product.description) {
    noItemDescription = productDescriptionComingSoon(product.description);
  }

  const category =
    product?.breadcrumbs && createCategoryPath(product.breadcrumbs);

  return {
    category,
    name: product.gaName,
    id: productCode,
    variant: product.selectedVariantSku ?? productCode,
    price: product.price?.price?.value ?? product.price?.highPrice?.value,
    brand: product.brand?.name,
    item_description_coming_soon: noItemDescription,
  };
};

export const dataLayerSaveForLaterAddToCart = (
  product: TrackCartEventItem,
  productCode: string,
  quantity: number
) => {
  const dataLayerProduct = createDataLayerProduct(product, productCode);

  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object
  TagManager.dataLayer({
    dataLayer: {
      event: 'ee save for later cart add',
      ecommerce: {
        add: {
          products: [{ ...dataLayerProduct, quantity }],
        },
      },
    },
  });
};
